/**
 * @fileoverview gRPC-Web generated client stub for org.couchers.public
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.26.1
// source: public.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_annotations_pb = require('./google/api/annotations_pb.js')

var google_api_httpbody_pb = require('./google/api/httpbody_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var annotations_pb = require('./annotations_pb.js')

var api_pb = require('./api_pb.js')
const proto = {};
proto.org = {};
proto.org.couchers = {};
proto.org.couchers.public = require('./public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.org.couchers.public.PublicClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.org.couchers.public.PublicPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.api.HttpBody>}
 */
const methodDescriptor_Public_GetPublicUsers = new grpc.web.MethodDescriptor(
  '/org.couchers.public.Public/GetPublicUsers',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_api_httpbody_pb.HttpBody,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_api_httpbody_pb.HttpBody.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.api.HttpBody)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.api.HttpBody>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.public.PublicClient.prototype.getPublicUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.public.Public/GetPublicUsers',
      request,
      metadata || {},
      methodDescriptor_Public_GetPublicUsers,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.api.HttpBody>}
 *     Promise that resolves to the response
 */
proto.org.couchers.public.PublicPromiseClient.prototype.getPublicUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.public.Public/GetPublicUsers',
      request,
      metadata || {},
      methodDescriptor_Public_GetPublicUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.public.GetPublicUserReq,
 *   !proto.org.couchers.public.GetPublicUserRes>}
 */
const methodDescriptor_Public_GetPublicUser = new grpc.web.MethodDescriptor(
  '/org.couchers.public.Public/GetPublicUser',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.public.GetPublicUserReq,
  proto.org.couchers.public.GetPublicUserRes,
  /**
   * @param {!proto.org.couchers.public.GetPublicUserReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.public.GetPublicUserRes.deserializeBinary
);


/**
 * @param {!proto.org.couchers.public.GetPublicUserReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.public.GetPublicUserRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.public.GetPublicUserRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.public.PublicClient.prototype.getPublicUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.public.Public/GetPublicUser',
      request,
      metadata || {},
      methodDescriptor_Public_GetPublicUser,
      callback);
};


/**
 * @param {!proto.org.couchers.public.GetPublicUserReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.public.GetPublicUserRes>}
 *     Promise that resolves to the response
 */
proto.org.couchers.public.PublicPromiseClient.prototype.getPublicUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.public.Public/GetPublicUser',
      request,
      metadata || {},
      methodDescriptor_Public_GetPublicUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.org.couchers.public.GetSignupPageInfoRes>}
 */
const methodDescriptor_Public_GetSignupPageInfo = new grpc.web.MethodDescriptor(
  '/org.couchers.public.Public/GetSignupPageInfo',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.org.couchers.public.GetSignupPageInfoRes,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.public.GetSignupPageInfoRes.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.public.GetSignupPageInfoRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.public.GetSignupPageInfoRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.public.PublicClient.prototype.getSignupPageInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.public.Public/GetSignupPageInfo',
      request,
      metadata || {},
      methodDescriptor_Public_GetSignupPageInfo,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.public.GetSignupPageInfoRes>}
 *     Promise that resolves to the response
 */
proto.org.couchers.public.PublicPromiseClient.prototype.getSignupPageInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.public.Public/GetSignupPageInfo',
      request,
      metadata || {},
      methodDescriptor_Public_GetSignupPageInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.org.couchers.public.GetVolunteersRes>}
 */
const methodDescriptor_Public_GetVolunteers = new grpc.web.MethodDescriptor(
  '/org.couchers.public.Public/GetVolunteers',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.org.couchers.public.GetVolunteersRes,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.public.GetVolunteersRes.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.public.GetVolunteersRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.public.GetVolunteersRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.public.PublicClient.prototype.getVolunteers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.public.Public/GetVolunteers',
      request,
      metadata || {},
      methodDescriptor_Public_GetVolunteers,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.public.GetVolunteersRes>}
 *     Promise that resolves to the response
 */
proto.org.couchers.public.PublicPromiseClient.prototype.getVolunteers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.public.Public/GetVolunteers',
      request,
      metadata || {},
      methodDescriptor_Public_GetVolunteers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.org.couchers.public.GetDonationStatsRes>}
 */
const methodDescriptor_Public_GetDonationStats = new grpc.web.MethodDescriptor(
  '/org.couchers.public.Public/GetDonationStats',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.org.couchers.public.GetDonationStatsRes,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.public.GetDonationStatsRes.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.public.GetDonationStatsRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.public.GetDonationStatsRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.public.PublicClient.prototype.getDonationStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.public.Public/GetDonationStats',
      request,
      metadata || {},
      methodDescriptor_Public_GetDonationStats,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.public.GetDonationStatsRes>}
 *     Promise that resolves to the response
 */
proto.org.couchers.public.PublicPromiseClient.prototype.getDonationStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.public.Public/GetDonationStats',
      request,
      metadata || {},
      methodDescriptor_Public_GetDonationStats);
};


module.exports = proto.org.couchers.public;

